<div class="ui-media-upload">
  <div class="ui-media-upload__header">
    <label class="ui-media-upload__label" [attr.for]="inputId">{{ label() }}</label>
    @if (showRequirement()) {
      <span class="ui-media-upload__requirement" aria-hidden="true">
        {{ requirementText() }}
      </span>
    }
  </div>

  <div class="ui-media-upload__items" role="list">
    @for (item of value(); track item.id) {
      <div class="ui-media-upload__item" role="listitem">
        <div class="ui-media-upload__preview">
          @if (item.kind === 'image') {
            <img [src]="item.url" [alt]="item.file.name" />
          } @else {
            <video
              [src]="item.url"
              muted
              preload="metadata"
              [attr.aria-label]="item.file.name"
              (loadedmetadata)="onVideoMetadata($event)"
            ></video>
            <span class="ui-media-upload__video-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="M9 7.5v9l7-4.5-7-4.5Z" fill="currentColor" />
              </svg>
            </span>
          }
        </div>

        <div class="ui-media-upload__actions">
          <button
            type="button"
            class="ui-media-upload__action"
            aria-label="Ver archivo"
            (click)="view(item)"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M2.5 12s3.4-6 9.5-6 9.5 6 9.5 6-3.4 6-9.5 6-9.5-6-9.5-6Z"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <circle
                cx="12"
                cy="12"
                r="2.5"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              />
            </svg>
          </button>
          <button
            type="button"
            class="ui-media-upload__action"
            aria-label="Descargar archivo"
            (click)="download(item)"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M12 3v12m0 0 4-4m-4 4-4-4M5 19h14"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button
            type="button"
            class="ui-media-upload__action ui-media-upload__action--danger"
            aria-label="Eliminar archivo"
            [disabled]="disabled()"
            (click)="remove(item)"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M4 7h16m-10 4v6m4-6v6M7 7l1 13h8l1-13M9 7V4h6v3"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    }

    @if (canAdd()) {
      <div
        class="ui-media-upload__picker"
        [class.ui-media-upload__picker--dragging]="dragging()"
        role="button"
        [attr.tabindex]="disabled() ? -1 : 0"
        [attr.aria-disabled]="disabled()"
        [attr.aria-required]="required() ? 'true' : null"
        [attr.aria-label]="pickerAriaLabel()"
        (click)="openPicker()"
        (keydown)="onKeydown($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <svg class="ui-media-upload__picker-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 15V4m0 0L8 8m4-4 4 4M5 15v4h14v-4"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>{{ selectLabel() }}</span>
        <input
          #fileInput
          class="ui-media-upload__native"
          type="file"
          [id]="inputId"
          [accept]="acceptAttr()"
          [multiple]="multiple()"
          [disabled]="disabled()"
          [attr.aria-required]="required() ? 'true' : null"
          (change)="onInputChange($event)"
        />
      </div>
    }
  </div>
</div>
